import styled from "styled-components";
import Image from "next/image";

const ServiceContainer = styled.div`
    text-align: center;
    color: #3E3E3E;

    header {
        color: #000;
        text-transform: inherit;
        letter-spacing: inherit;
        font-size: 1rem;
        text-align: center;
        margin-bottom: 20px;
    }

    header:before,
    header:after {
        content: "";
        background-color: #FFC0A0;
        height: 1px;
        position: absolute;
        width: 30%;
        top: 50%;
    }

    header:before {
        left: 0;
    }
    header:after {
        right: 0;
    }

    .content {
        text-align: left;
    }

    .media {
        height: 200px;
        border-bottom: 1px solid rgba(190, 190, 190, 0.25);
        margin-bottom: 20px;
        border-radius: 20px;
        overflow: hidden;
        border: 2px solid #FF5701;
    }
`;

type ServiceProps = {
    title: string;
    iconUrl: any;
    iconAlt?: string;
    children: any;
};

const Service: React.FC<ServiceProps> = ({ title, iconUrl, iconAlt = "", children }) => {
    return (
        <ServiceContainer>
            <header>
                {title}
            </header>

            <div className="media">
                <Image src={iconUrl} alt={iconAlt} />
            </div>

            <div className="content">
                {children}
            </div>
        </ServiceContainer>
    );
};

export default Service;
